import React, { Fragment } from "react";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import { defineMessages } from "react-intl";
import StateFormGroup from "assets/scripts/components/common/form/StateFormGroup/StateFormGroup";
import isEmpty from "assets/scripts/utils/isEmpty";
import getMaxLengthError from "assets/scripts/utils/getMaxLengthError";
import { REQUIRED, ERRORS } from "assets/scripts/constants/FormMessages";
import getStateError from "assets/scripts/utils/getStateError";
import validZip from "assets/scripts/utils/validZip";
const messages = defineMessages({
    addressLabel: {
        id: "forms.profileEdit.address.label",
        defaultMessage: "Address"
    },
    address2Label: {
        id: "forms.profileEdit.address2.label",
        defaultMessage: "Address 2"
    },
    cityLabel: {
        id: "forms.profileEdit.city.label",
        defaultMessage: "City"
    },
    cityHelp: {
        id: "forms.profileEdit.city.help",
        defaultMessage: "Example: Springfield"
    },
    stateLabel: {
        id: "forms.profileEdit.state.label",
        defaultMessage: "State"
    },
    stateHelp: {
        id: "forms.profileEdit.state.help",
        defaultMessage: "Example: AK"
    },
    zipLabel: {
        id: "forms.profileEdit.zip.label",
        defaultMessage: "Zip"
    },
    zipHelp: {
        id: "forms.profileEdit.zip.help",
        defaultMessage: "Example: 12345"
    }
});
export function getErrors(value) {
    return {
        address: isEmpty(value.address) ? REQUIRED : getMaxLengthError(value.address, 256),
        address2: getMaxLengthError(value.address2, 256),
        city: isEmpty(value.city) ? REQUIRED : getMaxLengthError(value.city, 128),
        state: getStateError(value.state, true),
        zip: isEmpty(value.zip) || !validZip(value.zip) ? ERRORS.ZIP : null
    };
}
export default function ProfileAddressInputs({ value, errors, backendErrors, onChange }) {
    const handleChange = (update) => onChange({
        ...value,
        ...update
    });
    return (<Fragment>
			<TextFormGroup name="address" label={messages.addressLabel} value={value.address} onChange={address => handleChange({ address })} error={errors.address} backendError={backendErrors.address} required inputProps={{
        autoComplete: "address-line1"
    }}/>

			<TextFormGroup name="address2" label={messages.address2Label} value={value.address2} onChange={address2 => handleChange({ address2 })} error={errors.address2} backendError={backendErrors.address2} inputProps={{
        autoComplete: "address-line2"
    }}/>

			<TextFormGroup name="city" className="form-group-city" label={messages.cityLabel} help={messages.cityHelp} value={value.city} onChange={city => handleChange({ city })} error={errors.city} backendError={backendErrors.city} required inputProps={{
        autoComplete: "address-level2"
    }}/>

			<StateFormGroup name="state" className="form-group-state" label={messages.stateLabel} help={messages.stateHelp} value={value.state} onChange={state => handleChange({ state })} error={errors.state} backendError={backendErrors.stateProvince} required inputProps={{
        autoComplete: "address-level1"
    }}/>

			<TextFormGroup name="zip" className="form-group-zip" label={messages.zipLabel} help={messages.zipHelp} value={value.zip} onChange={zip => handleChange({ zip })} error={errors.zip} backendError={backendErrors.postalCode} required inputProps={{
        autoComplete: "postal-code"
    }}/>
		</Fragment>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfileAddressInputs/ProfileAddressInputs.tsx